import React from 'react'
import Content from './Content'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
function PrivacyPolicyIndex() {
  return (
    <div  style={{fontFamily:"Poppins, sans-serif"}}>
      <Navbar />
      <Content />
      <Footer />
    </div>
  )
}

export default PrivacyPolicyIndex
